module.exports = __webpack_public_path__ + "img/36963-044.99f4cbee.jpg";